var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",class:( _obj = {}, _obj['btn-'+_vm.type] = true, _obj ),attrs:{"disabled":_vm.isDisabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("\n  "+_vm._s(_vm.btnTxt)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }